// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4540":"f922dc76","7860":"f922dc76","8723":"f922dc76"}[chunkId] + ".chunk.css";
};